<ion-grid class="ion-no-padding">
  <ion-row>
    <ion-back-button
      defaultHref="/home"
      icon="chevron-back-outline"
      class="primary-icon-color"
    ></ion-back-button>
  </ion-row>
  <ion-row
    class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center row-style"
  >
    <ion-card class="no-shadow ion-padding ion-text-center">
      <custom-icon
        [iconName]="image"
        [width]="250"
        [height]="250"
        colorClass="modalIcon"
        class="ion-padding" 
      ></custom-icon>
      <ion-text class="ion-no-padding">
        <p class="font20 font600 card-primary-text-color">{{ message | translate}}</p>
        <p class="fs-3 font500 message2 card-primary-text-color">{{message2 | translate}}</p>
      </ion-text>
      <ion-button
        expand="block"
        class="ion-no-margin fs-3 font500 primary-btn"
        routerLink="/my-membership"
      >
        <ion-ripple-effect></ion-ripple-effect>
        {{ "upgrade_membership_cmp.upgrade_now_btn" | translate }}
      </ion-button>
    </ion-card>
  </ion-row>
</ion-grid>
